
import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import LandingPageRoute from "@/pages/LandingPage";
import BlogPage from "@/pages/Blog";
import ContactPage from "@/pages/Contact";
import TermsPage from "@/pages/Terms";
import PrivacyPage from "@/pages/Privacy";
import DataProcessingPage from "@/pages/DataProcessing";
import CookiePolicyPage from "@/pages/CookiePolicy";
import FAQPage from "@/pages/FAQ";
import HelpPage from "@/pages/Help";
import AuthPage from "@/pages/auth/Auth";
import MarketResearch from "@/pages/MarketResearch";
import CompetitiveAnalysis from "@/pages/CompetitiveAnalysis";
import Reports from "@/pages/Reports";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Payment from "./pages/Payment";
import "@/App.css";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AuthProvider } from "@/auth/context/AuthContext";
import Index from "@/pages/Index";
import { ProtectedRoute } from "@/auth/components/ProtectedRoute";

// Add Manrope font
import { Helmet } from "react-helmet";

function App() {
  return (
    <AuthProvider>
      <SidebarProvider>
        <Helmet>
          <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap" />
        </Helmet>
        <div className="min-h-screen flex w-full">
          <div className="flex-1">
            <Routes>
              <Route path="/" element={<LandingPageRoute />} />
              <Route 
                path="/chat/*" 
                element={
                  <ProtectedRoute>
                    <Index />
                  </ProtectedRoute>
                } 
              />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/data-processing" element={<DataProcessingPage />} />
              <Route path="/cookie-policy" element={<CookiePolicyPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/help" element={<HelpPage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/market-research" element={<MarketResearch />} />
              <Route
                path="/competitive-analysis"
                element={<CompetitiveAnalysis />}
              />
              <Route path="/reports" element={<Reports />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/payment" element={<Payment />} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </div>
      </SidebarProvider>
    </AuthProvider>
  );
}

export default App;
